import { useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import AttivaCard from "../../../components/card/AttivaCard";
import { Loader } from "../../../components/loader/SpinnerLogo";
import useFetch from "../../../hooks/useFetch";
import useHandleErrors from "../../../hooks/useHandleErrors";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import { ExpirationService } from "../../../services/expiration/expirationService";
import { Client } from "../../../type/entities/client-type";
import ExpirationForm from "../ExpirationForm";

export default function ExpirationEdit() {

    const { id = "" } = useParams<{ id: string }>();
    const { handleErrors } = useHandleErrors();
    const navigate = useNavigate();
    const service = new ExpirationService();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [data, loading] = useFetch(useCallback(async () => {
        const response = await service.getExpiration(id as string);
        return response.getResponseData() as Client;
    }, [id]));

    const pageHeader = {
        title: 'Vencimiento',
        breadcrumb: [
            { name: 'Ventas' },
            { name: 'Gestión de contratos' },
            { name: 'Vencimientos', href: menuRoutes.expirations.path },
            { name: 'Editar Vencimiento' },
        ],
    };

    const handleSubmit = async (values: any) => {
        setIsLoading(true);
        try {
            const response = await (await service.editExpiration(values)).getResponseData();
            if (response.success) {
                navigate(-1);
                setTimeout(() => { toast.success("Vencimiento editado correctamente") }, 100);
            } else {
                handleErrors(response);
            }
        } catch (error: any) {
            toast.error('Error al editar el vencimiento');
        } finally {
            setIsLoading(false);
        }
    };

    if (loading) return <Loader />;

    return (
        <>
            <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb} />

            <AttivaCard title="Datos Principales">
                {(data !== null && data !== undefined) && <ExpirationForm data={data} submit={handleSubmit} isLoading={isLoading} />}
            </AttivaCard>
        </>
    );
}